// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2G3IifM1XCFQAyGR2IlReg\\=\\={padding:32px 40px 0}._2G3IifM1XCFQAyGR2IlReg\\=\\=.overflow-scroll{border-bottom:3px solid var(--gray50);max-height:320px;overflow:auto}", "",{"version":3,"sources":["/app/client_react/src/components/ModalBody/ModalBody.styl"],"names":[],"mappings":"AAEA,6BACE,mBAAS,CAET,6CACE,qCAAe,CACf,gBAAY,CACZ,aAAU","file":"ModalBody.styl","sourcesContent":["@import '../../../../client/styles/vars';\n\n:local(.global) {\n  padding: 32px 40px 0;\n\n  &.overflow-scroll {\n    border-bottom: 3px solid var(--gray50);\n    max-height: 320px;\n    overflow: auto;\n  }\n}\n"]}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "_2G3IifM1XCFQAyGR2IlReg=="
};
module.exports = ___CSS_LOADER_EXPORT___;
